import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('changes', {
        template: require('./changes.html'),
        controller: ChangesCtrl,
        controllerAs: 'vm'
    });

    ChangesCtrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        '$location',
        'ModalService',
        'QueryService',
        'SessionService',
        'logger'
    ];

    function ChangesCtrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        $location,
        ModalService,
        QueryService,
        SessionService,
        logger
    ) {

        var vm = this;
        vm.mainBackground = require('Images/project_dino_a_1024.png');
        vm.logo = require('Images/nav-logo.png');

        vm.id = $stateParams.id;

        vm.get_data = function(){
            
            var request = {
                method: 'GET',
                route: URLS.base + `/regular_class_item/${vm.id}/regular_class`,
            };

            
            QueryService.query(request)
                .then(
                    function(response) {
                        vm.submitted = true;
                        vm.item = response.data.data.data[0];
                    },
                    function(error) {
                        logger.errorFormatResponse(error);
                    }
                )
                .finally(function() {
                    vm.loading = false;
                });
        }

        vm.get_data();

        vm.reschedule = function(page){
            vm.item.reason = vm.reason
            var modal = {
                teacher: vm.item,
                page: page
            };

            ModalService.reschedule_modal(modal, vm.TPLS).then(
                function(response) {
                    
                },
                function(error) {
                    logger.errorFormatResponse(error);
                }
            );
        }

        vm.goHomeYoureDrunk = () => {
            $location.path('home-page');
        };

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/changes/changes.component.js